var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forced_choice"},[_c('div',{staticClass:"options"},_vm._l((_vm.options),function(option){return _c('div',{key:option,staticClass:"option",on:{"click":function($event){return _vm.onOptionClick(option)}}},[_vm._v(" "+_vm._s(option)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }